var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.67,
    height: 159.67,
    viewBox: "0 0 159.67 159.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.83,
    cy: 79.83,
    r: 69.7,
    fill: "#34abd8",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.49,64.2h5.67v31.27h-5.67c-5.46,0-9.9-4.43-9.9-9.9v-11.48c0-5.46,4.43-9.9,9.9-9.9Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61,64.2l14.36-10.78c1.87-1.4,4.54-.07,4.54,2.27v48.29c0,2.34-2.67,3.67-4.54,2.27l-14.36-10.78v-31.27Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.55,96.38c3.15-4.51,5.05-10.34,5.05-16.72s-1.83-11.99-4.87-16.46",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.33,101.82c2.94-6.59,4.62-14.14,4.62-22.17,0-7.89-1.62-15.32-4.47-21.83",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.14,107.05c3.16-8.33,4.93-17.62,4.93-27.4,0-9.64-1.72-18.8-4.8-27.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListen);
export default __webpack_public_path__ + "static/media/listen.3eadb404f1127551fcb462fb3c6db2d1.svg";
export { ForwardRef as ReactComponent };